export const CURRENCY = "$";
export var recordsLimit = 10;
export var recordsLimit50 = 50;
export const googleMapApiKey = "";

export const falsyArray = [
  null,
  undefined,
  "",
  0,
  false,
  NaN,
  "null",
  "undefined",
  "false",
  "0",
  "NaN",
];
export const fileTypesAllowed = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "video/mp4",
  "video/mpeg",
  "video/quicktime",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
export const videoFileTypes = ["mp4", "mpeg", "quicktime"];

export const allowedFileTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "image/*": [".png", ".jpeg", ".jpg"],
};
export const allowedDocTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
};
export const allowedImageTypes = {
  "image/*": [".png", ".jpeg", ".jpg", ".jfif", ".webp"],
};

export const STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const ROLE = {
  SUPER_ADMIN: "super-admin",
  USER: "user",
  COMPANY: "company",
};

export const USER_STATUS = {
  VERIFICATION_PENDING: "verification-pending",
  ACTIVE: "active",
  USER_DEACTIVATED: "user-deactivated",
  SYSTEM_DEACTIVATED: "system-deactivated",
};
export const SUBSCRIPTION_STATUS = {
  ACTIVE: "active",
  PENDING: "subscription-pending",
  CANCELLED: "subscription-cancelled",
  EXPIRED: "subscription-expired",
};
export const SUBSCRIPTION_INTERVAL = {
  MONTH: "month",
  YEAR: "year",
};
export const SUBSCRIPTION_TYPE = {
  FREE: "free",
  PAID: "paid",
};
export const SUBSCRIPTION_CATEGORY = {
  STANDARD: "standard",
  ENTERPRISE: "enterprise",
};
